import { useState, useEffect } from "react"
const TimersNew = ({
  delayResend = "900",
  setDelayTriggerTry,
  delayTriggerTry,
  setReTryEnable,
  setNumberOfTries,
  staticTexts,
  mobileData,
  tryAgaininmin = false,
  setExceededAttempts,
  setResendEnable,
  setVerifyDisable,
  resetError,
  setDelayTrigger,
}) => {
  const [delay, setDelay] = useState(+delayResend)
  const [intervalId, setIntervalId] = useState(null)
  useEffect(() => {
    if (delayTriggerTry) {
      setDelay(+delayResend)
      setDelayTriggerTry(false)
    }
  }, [delayTriggerTry])

  useEffect(() => {
    const timer = setInterval(() => {
      setDelay(delay - 1)
      localStorage.setItem("checkoutNumber_" + mobileData?.value, delay - 1)
    }, 1000)
    if (delay === 0) {
      clearInterval(timer)
      setDelayTriggerTry(false)
      setReTryEnable(false)
      setNumberOfTries(3)
      setExceededAttempts(false)
      setResendEnable(true)
      setVerifyDisable(false)
      resetError()
      setDelayTrigger(false)
      localStorage.removeItem("checkoutNumber_" + mobileData?.value)
    }
    return () => {
      clearInterval(timer)
    }
  }, [delay])

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setDelay(delay - 1)
  //     localStorage.setItem("checkoutNumber_" + mobileData?.value, delay - 1)
  //   }, 1000)
  //   if (delay === 0) {
  //     clearInterval(timer)
  //     setDelayTriggerTry(false)
  //     setReTryEnable(false)
  //     setNumberOfTries(3)
  //     setExceededAttempts(false)
  //     setResendEnable(true)
  //     setVerifyDisable(false)
  //     resetError()
  //     setDelayTrigger(false)
  //     localStorage.removeItem("checkoutNumber_" + mobileData?.value)
  //   }
  //   return () => {
  //     clearInterval(timer)
  //   }
  // }, [delay])
  return (
    <>
      <span className="auth-otp-modal__timer">
        {!tryAgaininmin ? staticTexts?.tryAgain : staticTexts?.tryagainmin}
      </span>
    </>
  )
}
export default TimersNew
